import { apiClient } from './client';
import { Usuario } from '../types';

export interface DadosCadastro {
  empresa: string;
  nome: string;
  email: string;
  celular?: string;
  senha: string;
  cnpj?: string;
  logo_base64?: string | null;
}

export interface DadosPerfil {
  empresa: string;
  nome: string;
  email: string;
  celular?: string;
  foto_base64?: string | null;
  logo_base64?: string | null;
  remover_foto?: boolean;
  remover_logo?: boolean;
}

export function registrar(dados: DadosCadastro): Promise<{ usuario: Usuario }> {
  return apiClient.post('/auth/cadastro', dados).then((res) => res.data);
}

export function login(
  identificador: string,
  senha: string,
  manterConectado: boolean
): Promise<{ usuario: Usuario }> {
  return apiClient
    .post('/auth/login', { identificador, senha, manter_conectado: manterConectado })
    .then((res) => res.data);
}

export function logout(): Promise<{ ok: boolean }> {
  return apiClient.post('/auth/logout').then((res) => res.data);
}

export function buscarUsuarioAtual(): Promise<{ usuario: Usuario | null }> {
  return apiClient.get('/auth/me').then((res) => res.data);
}

export function atualizarPerfil(dados: DadosPerfil): Promise<{ usuario: Usuario }> {
  return apiClient.post('/auth/perfil', dados).then((res) => res.data);
}

export function esqueciSenha(email: string): Promise<{ ok: boolean }> {
  return apiClient.post('/auth/esqueci-senha', { email }).then((res) => res.data);
}

export function redefinirSenha(token: string, senha: string): Promise<{ ok: boolean }> {
  return apiClient.post('/auth/redefinir-senha', { token, senha }).then((res) => res.data);
}
